/**
 * Routes job stream status updates into workflow session Redux state and queue completion.
 * Used by MultiProcessingModalManager hidden streams (and can be shared with other listeners).
 */

import {
  updateWorkflowSessionState,
  setCurrentlyProcessingSession,
  resetDocumentsState,
} from '../store/reducers';
import { clearWorkflowFiles } from './workflowFileCache';

const processNextDispatchedForSession = new Set();

export const resetProcessNextInQueueDispatchFlag = (workflowSessionId) => {
  if (workflowSessionId != null) processNextDispatchedForSession.delete(String(workflowSessionId));
};

/**
 * Dispatches processNextInQueue at most once per completed session per browser session
 * (until reset), so hidden streams + modal status effects do not double-fire.
 */
export const tryDispatchProcessNextInQueue = (completedSessionId) => {
  if (completedSessionId == null || completedSessionId === '') return;
  const key = String(completedSessionId);
  if (processNextDispatchedForSession.has(key)) return;
  processNextDispatchedForSession.add(key);

  window.dispatchEvent(
    new CustomEvent('processNextInQueue', {
      detail: { completedSessionId },
    })
  );
};

/**
 * Apply batched stream UI / step updates and run completion side effects (cache, queue).
 */
export function applyJobStreamSessionStatusUpdate(workflowSessionId, dispatch, statusUpdate) {
  if (!workflowSessionId || !dispatch || !statusUpdate) return;

  const stateUpdates = {};
  let completion = false;

  if (statusUpdate.areStepsCompleted === true) {
    completion = true;
  }

  if (statusUpdate.processingStatus === 'completed') {
    completion = true;
  }

  if (statusUpdate.processingStatus === 'error') {
    stateUpdates.isProcessing = false;
  }

  if (statusUpdate.processingStatus === 'processing') {
    stateUpdates.isProcessing = true;
  }

  if (statusUpdate.currentStep !== undefined) {
    stateUpdates.currentStep = statusUpdate.currentStep;
  }
  if (statusUpdate.completedSteps !== undefined) {
    stateUpdates.completedSteps = statusUpdate.completedSteps;
  }

  if (completion) {
    stateUpdates.stepsCompleted = true;
    stateUpdates.isProcessing = false;
  }

  if (Object.keys(stateUpdates).length > 0) {
    dispatch(updateWorkflowSessionState(workflowSessionId, stateUpdates));
  }

  if (!completion) return;

  clearWorkflowFiles(workflowSessionId);
  dispatch(setCurrentlyProcessingSession(null));

  try {
    const store = require('../store/store').default || require('../store/store');
    const activeId = store.getState()?.workflowSessions?.activeSessionId;
    if (activeId === workflowSessionId) {
      dispatch(resetDocumentsState());
    }
  } catch (e) {
    // non-fatal
  }

  tryDispatchProcessNextInQueue(workflowSessionId);
}
